import { render, staticRenderFns } from "./ViewGeoSwipes.vue?vue&type=template&id=7ecffea6"
import script from "./ViewGeoSwipes.vue?vue&type=script&lang=js"
export * from "./ViewGeoSwipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports